import React, { useEffect, useState } from 'react';
import { isNaN, isNil } from 'lodash';
import countdownHelper from '../../help/countdown';
import { get } from '../../common/httpService';
import setCustomStyle from './infobox';

const InfoboxSecondary = ({ secondaryVisible, closeBanner }) => {
    const customStyle = setCustomStyle(secondaryVisible);
    const [countDownDate, setCountDownDate] = useState(new Date(''));
    const [countDown, setCountDown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    const generateInfo = () => {
        const r = new RegExp(/(\[\[\s*countdown\s*\]\])+/gi);
        if (isNil(countDownDate) || isNaN(countDownDate.getTime()))
            return secondaryVisible.info.replace(r, '');

        const countDownText = countdownHelper.generateCountdownText(countDown);
        return secondaryVisible.info.replace(r, countDownText);
    };

    const getCountDown = async () => {
        const result = await get({
            url: `cms/getCountdownByTitle?title=${
                secondaryVisible.countdownTitle
                    ? secondaryVisible.countdownTitle
                    : ''
            }`,
        });
        console.log('countdown received: ', result);
        console.log('date: ', new Date(result.countdownDate));
        setCountDownDate(new Date(result.countdownDate));
    };

    useEffect(() => {
        getCountDown();
    }, []);

    useEffect(() => {
        if (
            !isNil(countDownDate) &&
            !isNaN(countDownDate.getTime()) &&
            Date.now() < countDownDate.getTime()
        ) {
            const interval = setInterval(() => {
                const c = countdownHelper.generateCountdown(countDownDate);
                setCountDown(c);
            }, 250);

            return () => clearInterval(interval);
        }
    }, [countDownDate]);

    return (
        <span className='ticker__item-secondary' style={customStyle}>
            <span
                dangerouslySetInnerHTML={{
                    __html: generateInfo(),
                }}></span>
            <i
                className='ticker__item-secondary-close'
                onClick={() => closeBanner(secondaryVisible)}>
                ×
            </i>
        </span>
    );
};

export default InfoboxSecondary;
